module.exports = "data:image/gif;base64,R0lGODlhDgBIAMIAAAAAAMnJycLa9vX19QAAAAAAAAAAAAAAACH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEAAAIALAAAAAAOAEgAAAMkKLrc/jDKSau9OOvNu/9gKI5kaZ5DmkoqNZxwLM90bd94ru8JADs="


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/button/s-arrow-light.gif
 ** module id = 399
 ** module chunks = 0
 **/